/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-05T19:13:41.34
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentRepairFeedbackType,
	listRentRepairFeedbackTypeInit,
	listRentRepairFeedbackTypeByAuthorizations,
	deleteRentRepairFeedbackType
} from '@api/rentmanage/RentRepairFeedbackType';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentRepairFeedbackType({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentRepairFeedbackType(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentRepairFeedbackTypeByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentRepairFeedbackTypeByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentRepairFeedbackTypeInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentRepairFeedbackTypeInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentRepairFeedbackType({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentRepairFeedbackType({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
